export type TVControlAction =
  | 'up' | 'down' | 'left' | 'right'
  | 'select' | 'back'
  | 'playPause' | 'seekBackward' | 'seekForward'
  | 'volumeUp' | 'volumeDown' | 'mute'
  | 'previousEpisode' | 'nextEpisode'
  | 'togglePlayerControls' | 'menu';

export type TVInputSource = 'keyboard' | 'gamepad' | 'native-tv';

export type TVInputEvent = {
  action: TVControlAction;
  source: TVInputSource;
  repeat?: boolean;
};

type TVActionListener = (event: TVInputEvent) => void;
const listeners = new Set<TVActionListener>();

export function subscribeTVActions(listener: TVActionListener) {
  listeners.add(listener);
  return () => { listeners.delete(listener); };
}

export function emitTVAction(event: TVInputEvent) {
  listeners.forEach((listener) => listener(event));
}

export function actionForNativeTVEvent(eventType?: string): TVControlAction | null {
  const normalized = eventType?.replace(/[^a-zA-Z0-9]/g, '').toLowerCase();
  const actions: Record<string, TVControlAction> = {
    up: 'up', down: 'down', left: 'left', right: 'right',
    select: 'select', enter: 'select', ok: 'select',
    back: 'back', escape: 'back', menu: 'menu',
    playpause: 'playPause', play: 'playPause', pause: 'playPause',
    mediaplaypause: 'playPause',
    seekbackward: 'seekBackward', rewind: 'seekBackward', mediarewind: 'seekBackward',
    seekforward: 'seekForward', fastforward: 'seekForward', mediafastforward: 'seekForward',
    volumeup: 'volumeUp', volup: 'volumeUp', keyvolup: 'volumeUp', audiovolumeup: 'volumeUp',
    volumedown: 'volumeDown', voldown: 'volumeDown', keyvoldown: 'volumeDown', audiovolumedown: 'volumeDown',
    mute: 'mute', audiovolumemute: 'mute',
    previous: 'previousEpisode', previoustrack: 'previousEpisode', mediatrackprevious: 'previousEpisode',
    next: 'nextEpisode', nexttrack: 'nextEpisode', mediatracknext: 'nextEpisode',
    toggleplayercontrols: 'togglePlayerControls',
  };
  return normalized ? actions[normalized] ?? null : null;
}
